import { Dialog, DialogModule } from "@angular/cdk/dialog";
import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Inject, LOCALE_ID, Output } from "@angular/core";
import { CloudinaryModule, lazyload, placeholder } from "@cloudinary/ng";
import { Cloudinary, CloudinaryImage } from "@cloudinary/url-gen";
import { scale } from "@cloudinary/url-gen/actions/resize";
import { Client } from "@interfaces";
import { SubdomainService } from "src/app/rest/subdomain.service";
import { LocalePickerDialogComponent } from "./locale-picker-dialog/locale-picker-dialog.component";

@Component({
    selector: "app-locale-picker",
    templateUrl: "./locale-picker.component.html",
    standalone: true,
    imports: [CommonModule, LocalePickerDialogComponent, CloudinaryModule, DialogModule ],
})
export class LocalePickerComponent {
    @Output() localePickerOpened = new EventEmitter();
    public img!: CloudinaryImage;
    public locales = {
        en: {
            name: "English",
            flag: "voyse/assets/flags/svg/110-united_kingdom",
            slug: "",
        },
        it: {
            name: "Italiano",
            flag: "voyse/assets/flags/svg/263-italy",
            slug: "it",
        },
        nl: {
            name: "Nederlands",
            flag: "voyse/assets/flags/svg/077-netherlands",
            slug: "nl",
        },
        fr: {
            name: "Français",
            flag: "voyse/assets/flags/svg/197-france",
            slug: "fr",
        },
        "fr-be": {
            name: "Belgique (Français)",
            flag: "voyse/assets/flags/svg/209-belgium",
            slug: "fr-be",
        },
        "th-th": {
            name: "ไทย",
            flag: "voyse/assets/flags/svg/088-thailand",
            slug: "th-th",
        },
        "en-my": {
            name: "Malaysia (English)",
            flag: "voyse/assets/flags/svg/207-malaysia",
            slug: "en-my",
        },
        "en-sg": {
            name: "Singapore (English)",
            flag: "voyse/assets/flags/svg/132-singapore",
            slug: "en-sg",
        },
        cy: {
            name: "Cymraeg",
            flag: "voyse/assets/flags/svg/246-wales",
            slug: "cy",
        },

    };
    public selectedLocales = {};
    public plugins = [lazyload(), placeholder({ mode: 'predominant-color' })];
    constructor(
        public dialog: Dialog,
        public subdomain: SubdomainService,
        @Inject(LOCALE_ID) public localeId: string
    ) {
        const cld = new Cloudinary({ cloud: { cloudName: "minirobot" } });
        this.img = cld.image(this.locales[this.localeId]?.flag ?? this.locales["en"].flag);
        this.img.resize(scale().width(30));
        this.subdomain.getClient().subscribe((client: Client) => {
            client.locales.forEach((locale) => {
                this.selectedLocales[locale] = this.locales[locale];
            });
        });
    }

    openDialog() {
        this.localePickerOpened.emit();
        this.dialog.open(LocalePickerDialogComponent, {
            height: "auto",
            minWidth: "300px",
            autoFocus: '__non_existing_element__',
            data: {
                locales: this.selectedLocales
            }
        });
    }
}
